<div class="rounded-2xl border border-gray-100 bg-white p-6 filters-shadow">
  <div class="flex flex-col gap-6">
    <div class="grid grid-cols-1 gap-4 md:grid-cols-4">
      <app-filter-input
        [label]="isArabic() ? 'المبلغ (من)' : 'Amount (From)'"
        [placeholder]="isArabic() ? 'ادخل المبلغ' : 'Enter amount'"
        [type]="'number'"
        [(value)]="filters().amountFrom"
        [isInvalid]="amountInvalid()"></app-filter-input>

      <app-filter-input
        [label]="isArabic() ? 'المبلغ (إلي)' : 'Amount (To)'"
        [placeholder]="isArabic() ? 'ادخل المبلغ' : 'Enter amount'"
        [type]="'number'"
        [(value)]="filters().amountTo"
        [isInvalid]="amountInvalid()"></app-filter-input>

      <app-filter-date-component
        [label]="isArabic() ? 'تاريخ الفاتورة (من)' : 'Invoice Date (From)'"
        [(value)]="filters().dateFrom"
        [isInvalid]="!!dateInvalid() || !!futureDateInvalid()"></app-filter-date-component>

      <app-filter-date-component
        [label]="isArabic() ? 'تاريخ الفاتورة (إلي)' : 'Invoice Date (To)'"
        [(value)]="filters().dateTo"
        [isInvalid]="!!dateInvalid() || !!futureDateInvalid()"></app-filter-date-component>
    </div>

    @if (amountInvalid()) {
      <p class="mt-[-10px] text-right text-[13px] text-red-500" i18n="@@amountErrorMsg">
        يجب أن يكون الحد الأقصى للقيمة أكبر من أو يساوي الحد الأدنى للقيمة.
      </p>
    }
    @if (futureDateInvalid()) {
      <p class="mt-[-10px] text-right text-[13px] text-red-500" i18n="@@futureDateErrorMsg">
        لا يمكن اختيار تواريخ في المستقبل.
      </p>
    }

    <div class="grid grid-cols-1 gap-4 md:grid-cols-4">
      <app-filter-input
        [label]="isArabic() ? 'رقم الفاتورة' : 'Invoice ID'"
        [placeholder]="isArabic() ? 'ادخل رقم الفاتورة' : 'Enter invoice ID'"
        [type]="'text'"
        [(value)]="filters().invoiceId"></app-filter-input>

      <app-filter-input
        [label]="isArabic() ? 'رقم الطلب' : 'Order ID'"
        [placeholder]="isArabic() ? 'ادخل رقم الطلب' : 'Enter order ID'"
        [type]="'text'"
        [(value)]="filters().orderId"></app-filter-input>

      <div class="hidden md:block"></div>
      <div class="hidden md:block"></div>
    </div>

    <hr class="mt-2 border-gray-200" />

    <div class="flex flex-col-reverse items-start justify-between gap-4 md:flex-row md:items-center">
      <app-filter-sorting-component
        [(orderBy)]="filters().orderBy"
        [orderDir]="filters().orderDir"
        [sortOptions]="sortOptions()"
        (toggleOrder)="toggleSortOrder()"></app-filter-sorting-component>

      <div class="flex items-center gap-3">
        <button
          (click)="onReset()"
          class="borderTabsColor textTabsColor hover-bg-primary-10 cursor-pointer rounded-[8px] border bg-white px-8 py-2.5 text-[14px] font-bold shadow-sm transition-colors"
          i18n="@@resetFilterBtn">
          Clear
        </button>
        <button
          (click)="onApply()"
          [disabled]="!isFormValid()"
          class="bgTabsColor cursor-pointer rounded-[8px] px-8 py-2.5 text-[14px] font-bold text-white shadow-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50"
          i18n="@@applyBtn">
          تطبيق
        </button>
      </div>
    </div>
  </div>
</div>
